import { Stack, Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Skeleton from "@mui/material/Skeleton"
import { useAtom } from "jotai"
import { baseAtom } from "../../../stores/jotai/base"

const skeletonSx = {
  backgroundColor: "#E6E6E6",
  my: 2,
  ml: 3
}
type NoteEditorSkeletionType ={
  isFindingLoading?:boolean;
  isBaseLoading?:boolean;
  allInterview?:number;
  interviewListOpenIcon?:any;
}
export default function NoteEditorSkeletion({
  isFindingLoading,
  isBaseLoading,
  interviewListOpenIcon
}:NoteEditorSkeletionType) {

  const showAnimation = isFindingLoading || isBaseLoading;
  const [base,setBase]=useAtom(baseAtom);

  const noteEditorRows = [...Array(5)]?.map((_,index) => ({
    skeleton: (
      <Skeleton
        key={index}
        variant="rounded"
        animation={showAnimation ? "pulse" : false}
        height={30}
        width={100}
        sx={{ backgroundColor: "#E6E6E6", mt: 5 }}
      />
    )
  }));

  const skeletonWidths = [420, 420, 470, 470, 420, 420, 470, 420, 420, 470, 470];

  return (
    <Box sx={{ height: "100%" }}>
      <Stack sx={{ height: "100%", width: "100%",backgroundColor: "#FFFFFF" }}>
        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            spacing={0}
            sx={{
              flexWrap: "wrap",
              gap: "8px",
              
            }}
          >
            <Stack direction="row" sx={{ alignItems: "center", flexGrow: "1" }}>
              {
                base?.discoveryFocusMode && interviewListOpenIcon
              }
              <Box p={1} sx={{ height: "100%", flexGrow: "1", marginRight: "auto" ,}}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "30px", }}
                >
                  <Typography
                    variant="subtitle1"
                    component="p"
                    fontSize="15px"
                    color="GrayText"
                    sx={{
                      borderBottom: "2px solid #b2b2b2",
                      width: "70px",
                      textAlign: "center"
                    }}
                  >
                    Notes
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="p"
                    fontSize="15px"
                    color="GrayText"
                  >
                    Analysis
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Stack>
        </Box>

        <Box
          sx={{
           backgroundColor: "#FFFFFF",
            height: "100%",
            borderRadius: "4px"
          }}
        >
          <Stack direction="row" justifyContent={"space-evenly"} mb={2}>
            {noteEditorRows?.map((row, index) => row?.skeleton)}
          </Stack>
          <Stack direction="column" justifyContent="center">
            {skeletonWidths?.map((width, index) => (
              <Skeleton
                key={index}
                variant="rounded"
                height={30}
                width={width}
                animation={showAnimation ? "pulse" : false}
                sx={skeletonSx}
              />
            ))}
          </Stack>
        </Box>
      </Stack>
    </Box>
  )
}
